import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
	EmergencyContact,
	LivingWill,
	PersonalInfo,
	PrimaryCarePhysician,
	Specialists,
} from 'src/app/beans/health-history/general-info.bean';
import { Config } from 'src/app/config/config';
import { Environment } from 'src/app/config/environment';
import { METHOD_TYPE } from 'src/app/constants/service.constants';
import { ServiceRouter } from '../core/http-service-router.service';
import { JwtHelper } from '../core/jwt-helper.service';

/**
 * contains api calls related to general info section of health history
 */
@Injectable()
export class LifestyleService {
	/**
	 * constructor
	 * @param environment
	 * @param serviceRouter
	 * @param config
	 */
	constructor(
		private jwtService: JwtHelper,
		private environment: Environment,
		private serviceRouter: ServiceRouter,
		private config: Config
	) {}

	/**
	 *
	 */
	getSafety(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.safety}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveSafety(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.safety}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getSubstanceAbuse(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.substanceAbuse}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveSubstanceAbuse(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.substanceAbuse}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
	getHowYouSleep(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouSleep}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveHowYouSleep(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouSleep}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getHowYouThink(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouThink}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveHowYouThink(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouThink}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getHowYouEat(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouEat}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveHowYouEat(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouEat}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
	getHealthGoals(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.healthGoals}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveHealthGoals(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.healthGoals}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getHowYouMove(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouMove}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveHowYouMove(apptID, data: PersonalInfo): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.howYouMove}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getWorkLifeDetails(apptID, haID): Observable<any> {
		if (!haID || haID == 0) {
			return new Observable(observer => {
				observer.next({ data: {} });
				observer.complete();
			});
		}
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.workLife}?epmsPID=${epmsPID}&apptID=${apptID}&healthAssessmentID=${haID}`,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 *
	 * @param data
	 */
	saveWorkLifeDetails(apptID, data): Observable<any> {
		const epmsPID = this.jwtService.getEpmsId();
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			`${this.config.url.newHealthAssessmentApi.workLife}?epmsPID=${epmsPID}&apptID=${apptID}`,
			METHOD_TYPE.SECURED_POST,
			data,
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
}
